
const NOT_FOUND = '404_NOT_FOUND_PAGE'

module.exports = {
    NOT_FOUND
}